export enum PLAN_RECURRING_INTERVAL_UNIT {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
}

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  CANCELED = 'canceled',
}

export enum INVOICE_STATUS {
  DRAFT = 'draft',
  OPEN = 'open',
  PAID = 'paid',
  UNCOLLECTIBLE = 'uncollectible',
  VOID = 'void',
}
